import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Meteor } from 'meteor/meteor';

import { Modal } from 'react-bootstrap';

import MapIframe from './MapIframe';
import GraphicIframe from './GraphicIframe';
import ExpandModalButton from './ExpandModalButton';
import OpenLinkInNewWindowButton from './OpenLinkInNewWindowButton';

import { GridContainer, Grid, GridBottomChild, GridTopChild } from './styles';

const MODALS = {
  TOP: 'top',
  BOTTOM: 'bottom'
};

const { defaultMapSource, defaultGraphicSource } = Meteor.settings.public;

const GridTwoHalvesHorizontal = ({
  gridBackgroundColor,
  heightToRemove,
  topGridChild,
  bottomGridChild,
  topGridChildURL,
  bottomGridChildURL,
  topGridChildExternalURL,
  bottomGridChildExternalURL,
  isPreview,
  showButtons
}) => {
  const [showTopButton, setTopButton] = useState(false);
  const [showBottomButton, setShowBottomButton] = useState(false);

  const [modalToShow, setModalToShow] = useState('');
  return (
    <>
      <GridContainer backgroundcolor={gridBackgroundColor} heightToRemove={heightToRemove}>
        <Grid>
          <GridTopChild
            height="50%"
            xs={12}
            backgroundcolor={gridBackgroundColor}
            onMouseEnter={() => setTopButton(true)}
            onMouseLeave={() => setTopButton(false)}
          >
            {React.cloneElement(topGridChild, { isPreview })}
            {showButtons && (
              <>
                <ExpandModalButton
                  showButton={showTopButton}
                  handleShow={() => setModalToShow(MODALS.TOP)}
                />
                <OpenLinkInNewWindowButton showButton={showTopButton} linkURL={topGridChildURL} />
                <OpenLinkInNewWindowButton
                  isExternal
                  showButton={showTopButton}
                  linkURL={topGridChildExternalURL}
                />
              </>
            )}
          </GridTopChild>
          <GridBottomChild
            height="50%"
            xs={12}
            backgroundcolor={gridBackgroundColor}
            onMouseEnter={() => setShowBottomButton(true)}
            onMouseLeave={() => setShowBottomButton(false)}
          >
            {React.cloneElement(bottomGridChild, { isPreview })}
            {showButtons && (
              <>
                <ExpandModalButton
                  showButton={showBottomButton}
                  handleShow={() => setModalToShow(MODALS.BOTTOM)}
                />
                <OpenLinkInNewWindowButton
                  showButton={showBottomButton}
                  linkURL={bottomGridChildURL}
                />
                <OpenLinkInNewWindowButton
                  isExternal
                  showButton={showBottomButton}
                  linkURL={bottomGridChildExternalURL}
                />
              </>
            )}
          </GridBottomChild>
        </Grid>
      </GridContainer>
      <Modal
        show={!isEmpty(modalToShow)}
        onHide={() => setModalToShow('')}
        dialogClassName="w-75 mw-100 mh-100"
      >
        <Modal.Header closeButton />
        <Modal.Body className="p-0" style={{ height: '85vh', width: '100%' }}>
          {modalToShow === MODALS.TOP && topGridChild}
          {modalToShow === MODALS.BOTTOM && bottomGridChild}
        </Modal.Body>
      </Modal>
    </>
  );
};
GridTwoHalvesHorizontal.defaultProps = {
  gridBackgroundColor: '#545554',
  heightToRemove: '5%',
  bottomGridChild: <GraphicIframe />,
  topGridChild: <MapIframe />,
  topGridChildURL: defaultGraphicSource,
  bottomGridChildURL: defaultMapSource,
  topGridChildExternalURL: '',
  bottomGridChildExternalURL: '',
  isPreview: false,
  showButtons: true
};

GridTwoHalvesHorizontal.propTypes = {
  gridBackgroundColor: PropTypes.string,
  heightToRemove: PropTypes.string,
  topGridChild: PropTypes.node,
  bottomGridChild: PropTypes.node,
  topGridChildURL: PropTypes.string,
  bottomGridChildURL: PropTypes.string,
  topGridChildExternalURL: PropTypes.string,
  bottomGridChildExternalURL: PropTypes.string,
  isPreview: PropTypes.bool,
  showButtons: PropTypes.bool
};

export default GridTwoHalvesHorizontal;
